module.exports = __webpack_public_path__ + "media/images/menu-icons/find-a-solution-f3d5dbc91dc8e03afd2fb6f6cbbad6bc.svg";